import { GetterTree } from 'vuex'
import { RootState } from '@/store'
import { SmartMarketingState } from '@/store/smartMarketing/index'
import { CredentialsType } from '@/api/types'

export const getters: GetterTree<SmartMarketingState, RootState> = {
    supportedPlatforms(): CredentialsType[] {
        return [
            CredentialsType.ACTIVE_CAMPAIGN,
            // CredentialsType.MAILCHIMP,
        ]
    },

    isActiveCampaign(state: SmartMarketingState): boolean {
        return state.credentialsType === CredentialsType.ACTIVE_CAMPAIGN
    },

    isMailchimp(state: SmartMarketingState): boolean {
        return state.credentialsType === CredentialsType.MAILCHIMP
    },

    isActivated(state: SmartMarketingState): boolean {
        return state.listId !== null
    },

    canUseActiveCampaign(state: SmartMarketingState): boolean {
        return state.credentialsType === CredentialsType.ACTIVE_CAMPAIGN
            && state.enabled
            && state.listId !== null
    },

    canUseEmma(state: SmartMarketingState): boolean {
        return state.credentialsType === CredentialsType.ACTIVE_CAMPAIGN
            && state.enabled
            && state.emmaListId !== null
    },

    canActivate(state: SmartMarketingState): boolean {
        if (state.listId !== null) {
            return false
        }

        if (state.credentialsType === CredentialsType.ACTIVE_CAMPAIGN) {
            return state.valid
                && state.apiUrl !== null
                && state.apiKey !== null
        }

        return false

    },

    credentialsState(state: SmartMarketingState): string {
        if (state.credentialsType === CredentialsType.ACTIVE_CAMPAIGN) {
            if (state.enabled && state.listId !== null) {
                return 'activated'
            }
        }

        if (state.enabled) {
            return 'enabled'
        }

        return 'disabled'
    },
}
